import { projectsAPI } from 'api';
import { call, put } from 'redux-saga/effects';
import { disableMarketingSuccess, disableMarketingFailed } from '../actions';

export default function* handleDisableMarketing({ payload }) {
  try {
    const data = yield call(projectsAPI.disableMarketing, {
      project: payload.id,
    });

    yield put(disableMarketingSuccess(data));
  } catch (e) {
    yield put(disableMarketingFailed(e));
  }
}
